module.exports = __webpack_public_path__ + "static/assets/41c325b3078a3e0e03d3e11b6b5751fb.svg";